import { newE2EPage } from "@stencil/core/testing";

const html = `
<uic-popover>
    <button slot="trigger">Label</button>
    <div>Conetent</div>
</uic-popover>
`;

describe("uic-popover", () => {
    it("should toggle 'open' by clicking on the trigger", async () => {
        const { component, trigger } = await renderTestPage();

        await trigger.click();
        expect(await component.getProperty("open")).toBe(true);

        await trigger.click();
        expect(await component.getProperty("open")).toBe(false);
    });

    it("should toggle 'open' using keys on the trigger", async () => {
        const { component, trigger } = await renderTestPage();
        await trigger.focus();
        await trigger.press("ArrowDown");
        expect(await component.getProperty("open")).toBe(true);

        await trigger.press("Escape");
        expect(await component.getProperty("open")).toBe(false);
    });
});

async function renderTestPage() {
    const page = await newE2EPage({
        html: html
    });

    const component = await page.find("uic-popover");
    const trigger = await page.find("uic-popover [slot='trigger']");

    return {
        page,
        component,
        trigger
    };
}
